import {
  CentreData,
  MappingData
} from "../../../../types/models/support/SupportApp";

export const centreData: CentreData[] = [
  {
    sNo: 1,
    categoryName:"Facing Connectivity Related Issues" ,
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
  {
    sNo: 2,
    categoryName:"Have Billing/ Charges/ Usage Related Issues" ,
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
  {
    sNo: 3,
    categoryName:"Need Assistance on Plan Change, Shifting/ Rewiring, Router, Security Refund, etc" ,
    parentCategory: "Parent Category",
    type: "Request",
    status: "Active",
  },
  {
    sNo: 4,
    categoryName:"Wish to review/ change Account Profile Details" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 5,
    categoryName:"Wish to discontinue services" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 6,
    categoryName:"Wish to discontinue services" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 7,
    categoryName:"	Any Other Issue/ Assistance Required/ Query" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 8,
    categoryName:"Refund Related Issue" ,
    parentCategory: "Parent Category",
    type: "	Request",
    status: "Active",
  },
  {
    sNo: 9,
    categoryName:"Installation and Shifting Related Issues ",
    parentCategory: "Parent Category",
    type: "	Complaint",
    status: "Active",
  },
]

export const mappingData: MappingData[] = [
  {
    sNo: 1,
    CRMCategory:"Network and Connectivity> Connection Not Working > No Power on Slave/ CPE" ,
    clientCategory: "Facing Connectivity Related Issues > Connection Not Working > CAB/PON LED is On",
    conditions: "	Complaint",
    status: "Active",
  },
  {
    sNo: 2,
    CRMCategory:"Have Billing/ Charges/ Usage Related Issues" ,
    clientCategory: "Parent Category",
    conditions: "	Complaint",
    status: "Active",
  },
  {
    sNo: 3,
    CRMCategory:"Need Assistance on Plan Change, Shifting/ Rewiring, Router, Security Refund, etc" ,
    clientCategory: "Parent Category",
    conditions: "Request",
    status: "Active",
  },
  {
    sNo: 4,
    CRMCategory:"Wish to review/ change Account Profile Details" ,
    clientCategory: "Parent Category",
    conditions: "	Request",
    status: "Active",
  },
  {
    sNo: 5,
    CRMCategory:"Wish to discontinue services" ,
    clientCategory: "Parent Category",
    conditions: "	Request",
    status: "Active",
  },
  {
    sNo: 6,
    CRMCategory:"Wish to discontinue services" ,
    clientCategory: "Parent Category",
    conditions: "	Request",
    status: "Active",
  },
  {
    sNo: 7,
    CRMCategory:"	Any Other Issue/ Assistance Required/ Query" ,
    clientCategory: "Parent Category",
    conditions: "	Request",
    status: "Active",
  },
  {
    sNo: 8,
    CRMCategory:"Refund Related Issue" ,
    clientCategory: "Parent Category",
    conditions: "	Request",
    status: "Active",
  },
  {
    sNo: 9,
    CRMCategory:"Installation and Shifting Related Issues ",
    clientCategory: "Parent Category",
    conditions: "	Complaint",
    status: "Active",
  },
]
